import React, { Component } from 'react';
import './Red.css';
import { Parallax } from 'react-scroll-parallax';

class Red extends Component {
  render() {
    return (
    	<div>

    	<div className="vyska">
    	<div className="redBackground">
	      <Parallax
	        className="custom-class"
	        offsetYMax={20 + '%'}
	        offsetYMin={-70 + '%'}
	        slowerScrollRate
	        tag="figure"
		    >
	        	<div className="druhy">Zajímá tě víc?<br></br><span style={{marginRight: "-390px", fontSize: "120" + "px", fontWeight:"bold"}}>Ptej se týmu!</span></div>
	    	</Parallax>
	    	</div>
		</div>
		<div className="yellow2" />
		</div>
    );
  }
}

export default Red;